import { Box, Card, Skeleton } from '@mui/material';

export const BgSkeleton = () => {
  return (
    <>
      <Skeleton
        variant="rounded"
        height={50}
        sx={{
          width: '90vw',
          mb: 5,
        }}
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          {Array.from({ length: 4 }).map((_, index) => (
            <Box
              key={`rules-${index}`}
              sx={{
                flex: { xs: '1 1 100%', sm: '1 1 45%', md: '1 1 19%' },
                minWidth: 150,
              }}
            >
              <Skeleton
                variant="rounded"
                height={110}
                sx={{
                  width: '100%',
                  borderRadius: '10px',
                }}
              />
            </Box>
          ))}
        </Box>

        <Box sx={{ display: 'flex', gap: 7.5, flexWrap: 'wrap' }}>
          <Box sx={{ flex: 1, minWidth: 300 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              {Array.from({ length: 3 }).map((_, index) => (
                <Box key={`positions-${index}`}>
                  <Card
                    sx={{
                      bgcolor: 'background.secondary',
                      borderRadius: 'large',
                      border: 'none',
                      height: '100%',
                      p: 2,
                    }}
                  >
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: '1rem', width: '80%' }}
                    />
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: '1rem', width: '60%' }}
                    />
                  </Card>
                </Box>
              ))}
            </Box>
          </Box>

          <Box sx={{ width: '60%', minWidth: 300 }}>
            <Card
              sx={{
                bgcolor: 'background.secondary',
                borderRadius: 'large',
                border: 'none',
                height: '100%',
                p: 2,
              }}
            >
              {Array.from({ length: 4 }).map((_, index) => (
                <Box key={`stats-${index}`} sx={{ mb: 1 }}>
                  <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: '1rem', width: '70%' }}
                  />
                </Box>
              ))}
            </Card>
          </Box>
        </Box>
      </Box>
    </>
  );
};
